import { TableColumn } from "collections/Table/Table";

export function generateTableHeaders(
  shown: TableColumn[],
  getTableHeaders: (column: string, title: string) => JSX.Element | Element
): (JSX.Element | Element)[] {
  const shownColumns = shown.map(column =>
    getTableHeaders(column.key, column.title)
  );
  if (shownColumns.length) {
    return shownColumns;
  } else {
    return [<th></th>];
  }
}
